import { COLOR_WH } from '../colors.constants';

export const colorsMenu = {
  colorsMenuBackground: COLOR_WH,
};
